import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function CandidatePagination({
  currentPage,
  pageCount,
  onPageChange,
}: {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}) {
  if (pageCount <= 1) {
    return null;
  }
  const pages = Array.from({ length: pageCount }, (_, index) => index + 1);

  return (
    <nav
      aria-label="Candidate pages"
      className="flex flex-wrap items-center justify-center gap-1 pt-2"
    >
      <Button
        variant="ghost"
        size="icon"
        aria-label="Previous page"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="h-11 w-11"
      >
        <ChevronLeft aria-hidden="true" size={16} />
      </Button>
      {pages.map((page) => (
        <Button
          key={page}
          variant={page === currentPage ? "outline" : "ghost"}
          size="icon"
          aria-label={`Page ${page}`}
          aria-current={page === currentPage ? "page" : undefined}
          onClick={() => onPageChange(page)}
          className={cn(
            "h-11 w-11 tabular-nums",
            page === currentPage && "border-primary text-primary",
          )}
        >
          {page}
        </Button>
      ))}
      <Button
        variant="ghost"
        size="icon"
        aria-label="Next page"
        disabled={currentPage === pageCount}
        onClick={() => onPageChange(currentPage + 1)}
        className="h-11 w-11"
      >
        <ChevronRight aria-hidden="true" size={16} />
      </Button>
    </nav>
  );
}
